import { DotsVerticalIcon } from "@heroicons/react/outline";
import { DropdownMenu } from "components/dropdownMenu";
import { SwitchButton } from "components/switchButton";
import { TooltipParagraph } from "components/tooltipParagraph";
import { IOrgItem } from "interfaces";
import moment from "moment";
import { formattedFilterParamsString } from "providerrs";
import { isHaveActionPermission } from "utills/helpers";

interface OrgTableProps {
  data?: IOrgItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const OrgTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: OrgTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Organization name
              </th>
              <th scope="col" className="th">
                Contact email
              </th>
              <th scope="col" className="th">
                Contact phone
              </th>
              <th scope="col" className="th">
                Event type
              </th>
              <th scope="col" className="th">
                Created at
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th">
                <span className="sr-only">Edit</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IOrgItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph
                    text={item.name_en}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td overflow-x-auto">{item.contact_email}</td>
                <td className="td overflow-x-auto">{item.contact_phone}</td>
                <td className="td overflow-x-auto capitalize">
                  {item.event_type.join(", ")}
                </td>
                <td className="td overflow-x-auto">
                  {moment(item.created).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={
                      !isHaveActionPermission(
                        "org_management",
                        "organization",
                        "edit"
                      )
                    }
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="float-right">
                    <DropdownMenu
                      label={<DotsVerticalIcon className="w-4" />}
                      items={[
                        {
                          label: "View",
                          href: `/organization/org/${item.id}`,
                          target: "_blank",
                        },
                        ...(isHaveActionPermission(
                          "org_management",
                          "organization",
                          "edit"
                        )
                          ? [
                              {
                                label: "Edit",
                                href: `/organization/org/${item.id}/edit`,
                                target: "_blank",
                              },
                            ]
                          : []),
                        ...(isHaveActionPermission(
                          "role_management",
                          "organization",
                          "view"
                        )
                          ? [
                              {
                                label: "Role",
                                href: `/organization/roles?${formattedFilterParamsString(
                                  [
                                    {
                                      field: "organization_id",
                                      operator: "eq",
                                      value: item.id,
                                    },
                                  ]
                                )}`,
                                target: "_blank",
                              },
                            ]
                          : []),
                        ...(isHaveActionPermission(
                          "account_management",
                          "organization",
                          "view"
                        )
                          ? [
                              {
                                label: "Account",
                                href: `/organization/accounts?${formattedFilterParamsString(
                                  [
                                    {
                                      field: "organization_id",
                                      operator: "eq",
                                      value: item.id,
                                    },
                                  ]
                                )}`,
                                target: "_blank",
                              },
                            ]
                          : []),
                      ]}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
